import { HTTP } from '../../../http-common';
import { createHelpers } from 'vuex-map-fields';
import { Employee } from '../../../models/Employee';
import { getField, updateField } from 'vuex-map-fields';
import { httpError } from '../../../models/httpError';

export const { mapFields: mapEmployeeFields } = createHelpers({
  getterType: `employee/getField`,
  mutationType: `employee/updateField`,
});

export const { mapMultiRowFields: mapEmployeeMultiRowFields } = createHelpers({
  getterType: 'employee/getField',
  mutationType: 'employee/updateField',
});

const state = {
  employees: [new Employee()],
  message: new httpError(),
};

//getters

const getters = {
  getField,
};

//Mutations
const mutations = {
  setRows(state, rows) {
    state.rows.length = 0;
    rows.forEach(data => {
      state.rows.push(data);
    });
  },
  setProgress(state, message) {
    state.message = message;
  },
  updateField,
};

//ACTIONS
const actions = {
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
  getUBDealers({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      let response = HTTP.get('DealerPortal/GetUBDealers');
      response
        .then(data => {
          if (data.status !== 200) resolve();
          var result = data.data;
          dispatch(
            'setMessage',
            new httpError({ message: 'Dealers retrieved', httpStatus: 200 })
          );
          resolve(result);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error getting dealers' + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  getEmployees({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      let response = HTTP.get('DealerPortal/GetAllEmployees');
      response
        .then(data => {
          if (data.status !== 200) resolve();
          var result = data.data;
          dispatch(
            'setMessage',
            new httpError({ message: 'Employees retrieved', httpStatus: 200 })
          );
          resolve(result);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error getting employees' + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  addEmployee({ commit, dispatch }, payload) {
    return new Promise(async (resolve, reject) => {
      let existingEmail = await HTTP.get(
        `DealerPortal/CheckEmployeeEmail/${payload.employee.email}`
      );

      if (existingEmail.data && !payload.isUpdating) {
        dispatch(
          'setMessage',
          new httpError({
            message: 'Employee email already exists!!!',
            httpStatus: 500,
          }),
          {
            root: true,
          }
        );
        reject('Employee email already exists!!!');
        return;
      }

      if (!payload.employee) {
        dispatch(
          'setMessage',
          new httpError({
            message: 'Invalid employee details',
            httpStatus: 500,
          }),
          {
            root: true,
          }
        );
        reject('no employee given');
        return;
      }

      if (
        (!existingEmail.data && !payload.isUpdating) ||
        payload.employee.id > 0
      ) {
        HTTP.post('DealerPortal/UpsertEmployee', payload)
          .then(data => {
            if (data.status == 200) {
              dispatch(
                'setMessage',
                new httpError({
                  message: 'Employee Saved',
                  httpStatus: 200,
                })
              );
              resolve(data.data);
            }
          })
          .catch(err => {
            dispatch(
              'setMessage',
              new httpError({
                message: err.response.data.message
                  ? `Auth0: ${err.response.data.message}`
                  : err.response.data,
                httpStatus: 500,
              })
            );
            reject('no employee given');
          });
      }
    });
  },
  deleteEmployee({ commit, dispatch }, employee) {
    return new Promise(async (resolve, reject) => {
      HTTP.delete('DealerPortal/DeleteEmployee', {
        data: employee,
      }).then(data => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Employees removed',
              httpStatus: 200,
            })
          );
          resolve(true);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error in removing employee',
              httpStatus: 500,
            })
          );
          reject('Error in removing employee');
        });
    })
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
